import { ChangeDetectionStrategy, Component } from '@angular/core';

import { RevealDirective } from '@ledgerly/common/browser';

import { StoreBadgesComponent } from '@ledgerly/shared/layout';
import { money } from '../nocturne/money';
import { currentLocale } from '../nocturne/locale';

@Component({
  selector: 'app-hero',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [StoreBadgesComponent, RevealDirective],
  templateUrl: './hero.component.html',
})
export class HeroComponent {
  private readonly locale = currentLocale();

  /**
   * The figure and the two numbers under it. 1,152 over 18 days is 64. The
   * hero states the answer and the rows state why. Keep them consistent.
   */
  protected readonly safeToSpend = money(64, this.locale);
  protected readonly left = money(1152, this.locale);

  /**
   * The trust row under the store badges.
   *
   * Three facts, not three claims. Each one is already stated somewhere the
   * app or this page has to stand behind: there is no bank connection, there
   * is no account, and nothing is sold. Nothing invented goes in this list.
   * Ratings and install counts belong here once the stores report real ones,
   * and not before. Inventing them would be the same integrity failure as an
   * invented privacy claim.
   */
  protected readonly trustChips = [
    $localize`:@@heroChipNoBank:No bank connection`,
    $localize`:@@heroChipNoAccount:No account`,
    $localize`:@@heroChipNothingSold:Nothing sold`,
  ];
}
